const theme = {
  config: {
    useColorSchemeMediaQuery: 'system',
  },
  colors: {
    text: '#454f5b',
    background: 'rgb(56, 64, 74)',
    primary: '#663399',
    secondary: '#000',
    success: '#00D100',
    failure: '#FF2E2E',
    mainBg: '#fff',
    linkMain: '#000',
    linkMainActive: '#000',
    tabBg: '#fff',
    tabBorder: '#aaa',
    tabTextColor: '#000',
    buttonBg: '#663399',
    buttonTextColor: '#fff',
    headingAccentStyles: '#663399',
    selectBg: '#fff',

    modes: {
      dark: {
        text: '#f8f8f2',
        background: '#333',
        primary: '#e0d649',
        secondary: '#282a36',
        mainBg: '#333',
        linkMain: '#50fa7b',
        linkMainActive: '#0f812c',
        tabBg: '#e0d649',
        tabBorder: '#e0d649',
        tabTextColor: '#282a36',
        buttonBg: '#e0d649',
        buttonTextColor: '#403f5a',
        headingAccentStyles: '#9cf867',
        selectBg: '#333',
      },
    },
  },
  fonts: {
    body: '-apple-system, Roboto, sans-serif, serif',
    heading: '-apple-system, Roboto, sans-serif, serif',
    monospace: 'Menlo, monospace',
  },
  styles: {},
  Tabs: {
    variants: {
      unstyled: {
        paddingY: '4',
        marging: '0',
        tab: {
          _selected: {
            boxShadow: 'none',
          },
        },
      },
    },
  },
}

export default theme
